module.exports = __webpack_public_path__ + "media/images/contest-disabled-label-right@3x-2386c5c0e903550f25898549de4fd60e.png";